var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAnpha = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90144 8.3252C5.91313 8.34014 5.92807 8.35222 5.94513 8.36053C5.96218 8.36884 5.98091 8.37316 5.99988 8.37316C6.01885 8.37316 6.03757 8.36884 6.05463 8.36053C6.07168 8.35222 6.08662 8.34014 6.09832 8.3252L7.84832 6.11113C7.91238 6.02988 7.85457 5.90957 7.74988 5.90957H6.59207V0.62207C6.59207 0.55332 6.53582 0.49707 6.46707 0.49707H5.52957C5.46082 0.49707 5.40457 0.55332 5.40457 0.62207V5.90801H4.24988C4.14519 5.90801 4.08738 6.02832 4.15144 6.10957L5.90144 8.3252ZM11.7186 7.77832H10.7811C10.7124 7.77832 10.6561 7.83457 10.6561 7.90332V10.3096H1.34363V7.90332C1.34363 7.83457 1.28738 7.77832 1.21863 7.77832H0.281128C0.212378 7.77832 0.156128 7.83457 0.156128 7.90332V10.9971C0.156128 11.2736 0.379565 11.4971 0.656128 11.4971H11.3436C11.6202 11.4971 11.8436 11.2736 11.8436 10.9971V7.90332C11.8436 7.83457 11.7874 7.77832 11.7186 7.77832Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnpha, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Anpha.fd0d6d6b.svg";
export { ForwardRef as ReactComponent };